module.exports = __webpack_public_path__ + "static/2-1fa7e55fbce57f797d893a90552d26c6.mp4";